// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"877":"e2f5f70e","6359":"75f031ad"}[chunkId] + ".chunk.css";
};